export const CLEAN_SYMBOL = '%%CLEAN%%'
